import React, { FC } from 'react'
import style from './PresenterBar.module.scss'
import classnames from 'classnames'
import GigStatus from '../GigStatus'
import SignalStrength, { SignalStrengthLevel } from '@bt-react/components/SignalStrength'
import FullscreenButton from '@bt-react/components/FullscreenButton'
import TalksPresenterControls from '../TalksPresenterControls'
import { ParticipantInformationInterface } from '../../dataStore/reducers/docs/syncUi/types'

export interface PresenterBarProps {
  networkQuality?: number | null
  participant?: ParticipantInformationInterface
  isObserver: boolean
}

const PresenterBar: FC<PresenterBarProps> = ({ networkQuality, participant, isObserver }) => {

  return <div
    className={classnames(style['PresenterBar--flex-vertical-center'], style['PresenterBar'])}
    data-bdd='presenter-bar'
  >
    <div
      className={classnames(
        style['PresenterBar--flex-vertical-center'],
        style['PresenterBar-Section'],
        style['PresenterBar-Status']
      )}
      data-bdd='presenter-bar-talk-status'
    >
      <GigStatus invert={true} />
    </div>
    <div
      className={classnames(
        style['PresenterBar--flex-vertical-center'],
        style['PresenterBar-Section'],
        style['PresenterBar-Controls']
      )}
      data-bdd='presenter-bar-controls'
    >
      {
        participant && !isObserver &&
        <TalksPresenterControls
          participant={participant}
          dataBdd='presenter-bar-local-controls'
        />
      }
    </div>
    <div
      className={classnames(
        style['PresenterBar--flex-vertical-center'],
        style['PresenterBar-Section'],
        style['PresenterBar-Network']
      )}
      data-bdd='presenter-bar-network'
    >
      {
        typeof networkQuality === 'number' &&
        <SignalStrength
          size='s'
          level={networkQuality as SignalStrengthLevel} />
      }
    </div>
    <div
      className={classnames(
        style['PresenterBar--flex-vertical-center'],
        style['PresenterBar-Section'],
        style['PresenterBar-Fullscreen']
      )}
      data-bdd='presenter-bar-fullscreen'
    >
      <FullscreenButton />
    </div>
  </div>

}

export default PresenterBar
